/* eslint-disable react-hooks/exhaustive-deps */
import { PureComponent, Fragment, useEffect, useState } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import Papa from 'papaparse';

import {
  Button,
  Grid,
  Modal,
  Popup,
  Segment,
  Tab,
  Input,
  Icon,
} from 'semantic-ui-react';

import {
  EvalPlanDisable,
  CustomAccordion,
  BrowseFile,
} from '../../../../components';

import {
  evalPlanManage,
  evalManage,
  evalPlanManageComplete,
  deleteEvaluationPlan,
  updateEvaluationPlan,
  updateEvaluationPlanName,
  evaluationPlanTransformSelfAssess,
  getProjectOutcomeSummary,
  updateOutcomeChart,
  uploadActivityByMultipleObjectives,
  updateSeriesSubtitle,
  deleteSeriesSubtitle,
  getEvalReasons,
  getEvalAssesmentTypes,
  getEvaluationPlans,
} from '../../../../store/actions';

import {
  isEmpty,
  map,
  get,
  find,
  concat,
  flattenDeep,
  sum,
  orderBy,
} from '../../../../utils/lodash';

import { ContentAndHeaderEvaluation, getPageDisable } from '../../../../utils';
import { INSTANCE_WITH_CULTURE_COUNTS } from '../../../../utils/instanceConstant';

import {
  formatEvaluationPlanDisplayName,
  getEvaluationPlanBaseName,
} from '../../../../utils/evaluationPlan';

import editIcon from '../../../../assets/edit-icon.svg';

import { EvaluationQuestion } from './evaluationQuestion';
import ActivityEvaluationSurvey from './activityEvaluationSurvey';
import SurveyContainer from './surveyContainer';

import '../activity.scss';

// TODO:i18n -> should be based on tag, not a label!
const formatEvaluationResponseLabel = (t, response) =>
  response === t('survey.self_assessed') ? t('survey.mgr_assessed') : response;

const ParticipantGroupLabel = ({ t, group }) => {
  const name = get(group, 'targetGroup.name', '-');
  // participants for a eval plan can either come from the activity type groups (e.g active participants,
  // paid participants ect..), sub groups, or subgroups that vary across a multistage evaluation series
  const count =
    get(group, 'participantCount', null) ??
    get(group, 'targetGroup.actualSize', null) ??
    get(group, 'targetGroup.size', null);
  if (count == null) return name;
  return (
    <>
      {name}{' '}
      <span className="participant-group-count">
        - {t('common.peoplez', { count: Number(count) })}
      </span>
    </>
  );
};

const getCsvUploadWarningStorageKey = (projectId, evaluationPlanId) =>
  `csv-upload-warning:${projectId}:${evaluationPlanId}`;

const EvaluationPlanMeasure = ({
  evalPlan,
  user,
  helpTips,
  updateEvaluationPlanName,
  updateSeriesSubtitle,
  currentActivity,
  deleteSeriesSubtitle,
  t,
}) => {
  const [isSubtitleDeleteLoading, setIsSubtitleDeleteLoading] = useState(false);
  const [isNameInputVisible, setIsNameInputVisible] = useState(false);
  const [isSubtitleVisible, setIsSubtitleVisible] = useState(false);
  const [isDeleteVisible, setIsDeleteVisible] = useState(false);
  const [evaluationName, setEvaluationName] = useState('');
  const [title, setTitle] = useState(get(evalPlan, 'name', ''));
  const [subtitleName, setSubtitleName] = useState(
    get(evalPlan, 'seriesSubtitle', null)
  );
  const [modalSubtitleName, setModalSubtitleName] = useState(
    get(evalPlan, 'seriesSubtitle', null)
  );

  const selfAssessed = get(evalPlan, 'method.response', '') === 'Self-assessed';

  const isCompleted = Boolean(
    get(evalPlan, 'dateMeasured', null) && !get(evalPlan, 'isDisabled', false)
  );

  const responsesCollected =
    Number(get(evalPlan, 'actualParticipantsEvaluated', 0)) || 0;
  const robustResponseCount = Math.max(
    responsesCollected,
    0,
    ...map(get(evalPlan, 'evaluationQuestions', []), (question) =>
      Number(get(question, 'actualParticipantsEvaluated', 0))
    ),
    get(evalPlan, 'haveResponses', false) ? 1 : 0
  );
  const participantGroups = get(evalPlan, 'participantGroups', []);
  const groupLiveCount = (group) =>
    get(group, 'participantCount', null) ??
    get(group, 'targetGroup.actualSize', null) ??
    get(group, 'targetGroup.size', null);
  const liveGroupCounts = participantGroups
    .map(groupLiveCount)
    .filter((count) => count != null)
    .map(Number);
  const listedParticipants =
    liveGroupCounts.length > 0
      ? liveGroupCounts.reduce((sum, count) => sum + count, 0)
      : Number(get(evalPlan, 'totalParticipants', 0)) || 0;

  const responsesExceedParticipants =
    !isCompleted && robustResponseCount > listedParticipants;
  const soleGroup =
    participantGroups.length === 1 ? participantGroups[0] : null;
  const soleGroupLiveCount = soleGroup ? groupLiveCount(soleGroup) : null;
  const soleGroupHasZeroListed =
    soleGroup != null &&
    soleGroupLiveCount != null &&
    Number(soleGroupLiveCount) === 0;
  const soleGroupZeroButHasResponses =
    !isCompleted &&
    !responsesExceedParticipants &&
    soleGroupHasZeroListed &&
    robustResponseCount > 0;

  useEffect(() => {
    setTitle(formatEvaluationPlanDisplayName(evalPlan));
  }, [evalPlan]);

  const getEvaluationQuestionsOrderedByOutcome = () => {
    return orderBy(evalPlan?.evaluationQuestions || [], ['outcomeId'], ['asc']);
  };

  const handleDeleteSubtitle = async () => {
    try {
      setIsSubtitleDeleteLoading(true);
      await deleteSeriesSubtitle(
        currentActivity.id,
        evalPlan.id,
        toggleSubtitleDeleteModal
      );
      setIsSubtitleDeleteLoading(false);
      toggleSubtitleDeleteModal(false);
      setSubtitleName('');
    } catch (error) {
      console.error(error);
    }
  };

  const toggleSubtitleDeleteModal = (value) => {
    setIsSubtitleVisible(false);
    setIsDeleteVisible(value);
    setIsSubtitleDeleteLoading(false);
    setSubtitleName(null);
    setModalSubtitleName(null);
  };

  const handleChange = async () => {
    let value = {
      name: evaluationName,
    };
    await updateEvaluationPlanName(currentActivity.id, evalPlan.id, value);

    setIsNameInputVisible(false);
  };

  const subtitleHandleChange = () => {
    updateSeriesSubtitle(currentActivity.id, evalPlan.id, modalSubtitleName);
    setSubtitleName(modalSubtitleName);
    setIsSubtitleVisible(false);
  };

  const pageDisabled = getPageDisable(
    currentActivity,
    user,
    'project.edit.evaluationPlan'
  );

  const canEditEvaluation = !pageDisabled && currentActivity.statusId !== 3;

  return (
    <Fragment>
      <Grid>
        <Grid.Row></Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            <div className="evaluation-name-column">
              <label className="evaluation-heading-doc">{title} </label>
              {(evalPlan.seriesParentId === null ||
                evalPlan.seriesParentId === evalPlan.id) &&
              canEditEvaluation ? (
                <Modal
                  className="evalation-model"
                  open={isNameInputVisible}
                  onOpen={() => setIsNameInputVisible(true)}
                  closeIcon={
                    <Icon
                      onClick={() => setIsNameInputVisible(false)}
                      name="close"
                      className="closeicon"
                    />
                  }
                  size="small"
                  trigger={
                    <div className="evaluation-edit-icon">
                      <img
                        className="icons-edit"
                        src={editIcon}
                        alt="icon"
                        onClick={() => {
                          setEvaluationName(evalPlan.name);
                        }}
                      />
                    </div>
                  }
                >
                  <Modal.Header>
                    {t('activity.evaluation.evaluation_plan_rename')}
                  </Modal.Header>
                  <Modal.Content>
                    <div>
                      <div className="evaluation-label">
                        {' '}
                        {t('activity.evaluation.new_evaluation_name')}
                      </div>
                      <Input
                        type="text"
                        className="evaluation-heading-input"
                        onChange={(e) => setEvaluationName(e.target.value)}
                        value={evaluationName}
                      />
                    </div>
                  </Modal.Content>
                  <Modal.Actions>
                    <Button
                      className="modal-cancel"
                      onClick={() => {
                        setIsNameInputVisible(false);
                      }}
                    >
                      {t('actions.cancel')}
                    </Button>
                    <Button
                      className="modal-proceed"
                      onClick={() => handleChange()}
                    >
                      {t('actions.save')}
                    </Button>
                  </Modal.Actions>
                </Modal>
              ) : null}
              {evalPlan.seriesParentId === evalPlan.id &&
                !pageDisabled &&
                currentActivity.statusId !== 3 && (
                  <label className="eval-button-separate"> | </label>
                )}
              {evalPlan.seriesParentId !== null &&
              !pageDisabled &&
              currentActivity.statusId !== 3 ? (
                <>
                  <Modal
                    open={isSubtitleVisible}
                    onOpen={() => setIsSubtitleVisible(true)}
                    size="tiny"
                    closeIcon={
                      <Icon
                        onClick={() => setIsSubtitleVisible(false)}
                        name="close"
                        className="closeicon"
                      />
                    }
                    trigger={
                      <div className="evaluation-subtitle">
                        {subtitleName ? (
                          <>
                            <Icon name="edit" /> {subtitleName}
                          </>
                        ) : (
                          <>
                            <Icon name="plus" />{' '}
                            {t('activity.evaluation.add_subtitle')}
                          </>
                        )}
                      </div>
                    }
                  >
                    <Modal.Header>
                      {subtitleName
                        ? t('specific_actions.edit_subtitle')
                        : t(
                            'activity.evaluation.add_subtitle_to_evaluation_series'
                          )}
                    </Modal.Header>
                    <Modal.Content>
                      <div>
                        <div className="evaluation-label">
                          {' '}
                          {t('activity.evaluation.new_evaluation_name')}
                        </div>
                        <Input
                          type="text"
                          className="evaluation-heading-input"
                          onChange={(e) => setModalSubtitleName(e.target.value)}
                          value={modalSubtitleName}
                        />
                      </div>
                    </Modal.Content>
                    <Modal.Actions>
                      <div className="d-flex mt-2">
                        <div className="">
                          {subtitleName && (
                            <Button
                              className="modal-delete"
                              onClick={() => toggleSubtitleDeleteModal(true)}
                            >
                              {t('actions.delete')}
                            </Button>
                          )}
                        </div>
                        <div className="ml-auto">
                          <Button
                            className="modal-cancel mr-2"
                            onClick={() => setIsSubtitleVisible(false)}
                          >
                            {t('actions.cancel')}
                          </Button>
                          <Button
                            onClick={() => subtitleHandleChange()}
                            className="modal-proceed"
                          >
                            {subtitleName
                              ? t('actions.save')
                              : t('actions.add')}
                          </Button>
                        </div>
                      </div>
                    </Modal.Actions>
                  </Modal>
                </>
              ) : (
                <div className="evaluation-subtitle-lbl">{subtitleName}</div>
              )}
              <SubtitleDeleteModal
                subtitleDeleteModal={isDeleteVisible}
                handleDeleteSubtitle={handleDeleteSubtitle}
                toggleSubtitleDeleteModal={toggleSubtitleDeleteModal}
                subtitleDeleteLoading={isSubtitleDeleteLoading}
                t={t}
              />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={3}>
          <Grid.Column
            mobile={5}
            tablet={5}
            computer={5}
            className="eval-plan-objective-row-documentation"
          >
            <ContentAndHeaderEvaluation title={t('common.objective')}>
              <ul className="outcome-title-ul-custom">
                {map(
                  getEvaluationQuestionsOrderedByOutcome(),
                  (evaluation, key) => (
                    <li key={`evaluation+plan_section_${key}`}>
                      {get(evaluation, 'outcome.title', '-')}
                    </li>
                  )
                )}
              </ul>
            </ContentAndHeaderEvaluation>
          </Grid.Column>
          <Grid.Column
            mobile={5}
            tablet={5}
            computer={5}
            className="eval-plan-eval-grp-row-documentation"
          >
            <ContentAndHeaderEvaluation
              title={t('activity.evaluation.evaluation_groups')}
            >
              {map(get(evalPlan, 'participantGroups', []), (evaluation, i) => (
                <span key={i}>
                  <ParticipantGroupLabel t={t} group={evaluation} />
                </span>
              ))}
            </ContentAndHeaderEvaluation>
          </Grid.Column>
          <Grid.Column
            mobile={5}
            tablet={5}
            computer={5}
            className="eval-plan-eval-info-row-documentation"
          >
            <ContentAndHeaderEvaluation
              title={t('activity.evaluation.evaluation_information')}
            >
              {selfAssessed
                ? formatEvaluationResponseLabel(
                    t,
                    get(evalPlan, 'method.response', '-')
                  )
                : `${get(evalPlan, 'method.method', '-')} - ${get(
                    evalPlan,
                    'method.response',
                    '-'
                  )}`}
            </ContentAndHeaderEvaluation>
          </Grid.Column>
        </Grid.Row>
        {responsesExceedParticipants && (
          <Grid.Row>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div className="issues-box-info eval-plan-participant-mismatch-note">
                <div className="padding-issue">
                  <Icon name="info circle" />
                  <span>
                    {selfAssessed ? (
                      t(
                        'activity.evaluation.participants_considered_exceeds_target_self_assessed',
                        {
                          count: robustResponseCount,
                          listed: listedParticipants,
                        }
                      )
                    ) : (
                      <Trans
                        i18nKey="activity.evaluation.responses_exceed_total_participants"
                        values={{
                          count: robustResponseCount,
                          listed: listedParticipants,
                        }}
                        components={{
                          planLink: (
                            <Link
                              className="mismatch-note-link"
                              to={`/activities/${currentActivity.id}/activity-plan`}
                              state={{ scrollTo: 'projected-outputs' }}
                            />
                          ),
                        }}
                      />
                    )}
                  </span>
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        )}
        {soleGroupZeroButHasResponses && (
          <Grid.Row>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div className="issues-box-info eval-plan-participant-mismatch-note">
                <div className="padding-issue">
                  <Icon name="info circle" />
                  <span>
                    {selfAssessed ? (
                      t(
                        'activity.evaluation.participants_considered_but_group_listed_zero_self_assessed',
                        { count: robustResponseCount }
                      )
                    ) : (
                      <Trans
                        i18nKey="activity.evaluation.responses_recorded_but_group_listed_zero"
                        values={{ count: robustResponseCount }}
                        components={{
                          planLink: (
                            <Link
                              className="mismatch-note-link"
                              to={`/activities/${currentActivity.id}/activity-plan`}
                              state={{ scrollTo: 'projected-outputs' }}
                            />
                          ),
                        }}
                      />
                    )}
                  </span>
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </Fragment>
  );
};

class SubtitleDeleteModalComponent extends PureComponent {
  render() {
    const {
      subtitleDeleteModal,
      handleDeleteSubtitle,
      toggleSubtitleDeleteModal,
      deleteSeriesSubtitleLoading,
      t,
    } = this.props;
    return (
      <Modal
        open={subtitleDeleteModal}
        onOpen={() => toggleSubtitleDeleteModal(true)}
        closeIcon={
          <Icon
            onClick={() => toggleSubtitleDeleteModal(false)}
            name="close"
            className="closeicon"
          />
        }
        size="small"
      >
        <Modal.Header>
          {t('activity.evaluation.delete_confirmation')}
        </Modal.Header>
        <Modal.Content>
          <p>{t('activity.evaluation.delete_subtitle_confirmation')}</p>

          <div className="participant-delete-button-container">
            <Button
              onClick={() => toggleSubtitleDeleteModal(false)}
              className="modal-cancel"
            >
              {t('actions.cancel')}
            </Button>
            <Button
              className="modal-proceed"
              onClick={() => handleDeleteSubtitle()}
              content={t('actions.delete')}
              type="submit"
              loading={deleteSeriesSubtitleLoading}
              negative
            />
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export const SubtitleDeleteModal = withTranslation()(
  SubtitleDeleteModalComponent
);

const EvaluationPlanCharts = ({
  checked,
  setToggle,
  setChartToReport,
  ...props
}) => {
  const { evalPlan, isFileChanged } = props;
  const [selectedObjective, setObjective] = useState(null);
  const [objectives, setObjectives] = useState([]);
  const [one = {}] = get(evalPlan, 'evaluationQuestions', []);

  useEffect(() => {
    initOrderedObjectives();
  }, []);

  useEffect(() => {
    initOrderedObjectives();
  }, [isFileChanged]);

  const initOrderedObjectives = () => {
    const objectiveId = get(one, 'objectiveId', null);
    if (!objectiveId) {
      return [];
    }

    setObjective(objectiveId);
    const getEval = find(
      evalPlan.evaluationQuestions,
      (evaluation) => evaluation.objectiveId === objectiveId
    );
    setToggle(get(getEval, 'inReport', true));

    const getObjectives = map(
      get(evalPlan, 'evaluationQuestions', []),
      (obj) => {
        return {
          key: obj.objectiveId,
          text: get(obj, 'outcome.title', '-'),
          value: obj.objectiveId,
          outcomeId: obj.outcomeId,
        };
      }
    );

    // make sure objectives are ordered by outcome id
    setObjectives(orderBy(getObjectives, ['outcomeId'], ['asc']));
  };

  const changeObjective = (e, data) => {
    let objectiveId = objectives[data.activeIndex].value;
    setObjective(objectiveId);
    const getEval = find(
      evalPlan.evaluationQuestions,
      (evaluation) => evaluation.objectiveId === objectiveId
    );
    setToggle(get(getEval, 'inReport', true));
  };

  const renderTabs = () => {
    const outcomes = map(objectives, (objective, i) => {
      return {
        menuItem: get(objective, 'text', '-'),
        render: () => (
          <Tab.Pane key={i} menu={{ secondary: true, pointing: true }}>
            <div className="url-card ">
              {map(evalPlan.evaluationQuestions, (evaluation, i) => {
                if (evaluation.objectiveId === selectedObjective) {
                  return (
                    <EvaluationQuestion
                      objectiveName={get(objective, 'text', '-')}
                      evaluation={find(
                        evalPlan.evaluationQuestions,
                        (evaluation) =>
                          evaluation.objectiveId === selectedObjective
                      )}
                      setChartToReport={() =>
                        setChartToReport(!checked, selectedObjective)
                      }
                      checked={checked}
                      evalPlan={evalPlan}
                      key={i}
                      index={i}
                      currentState="project.edit.evaluationPlan"
                      selectedObjective={selectedObjective}
                      isFileChanged={isFileChanged}
                      {...props}
                    />
                  );
                }
              })}
            </div>
          </Tab.Pane>
        ),
      };
    });
    const newArray = concat(outcomes);
    return newArray;
  };

  return (
    <Fragment>
      {isFileChanged ? (
        <Segment loading={isFileChanged}></Segment>
      ) : (
        <Tab
          className="tabs-graph"
          menu={{ secondary: true, pointing: true }}
          panes={renderTabs()}
          onTabChange={(e, data) => changeObjective(e, data)}
        />
      )}
    </Fragment>
  );
};

class UploadCsv extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      value: {},
      file: null,
      isNoFile: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  setFile = (file) => {
    this.setState({ file });
  };

  getNegativeImpactEntryCount = (file, evalPlan) => {
    const { t } = this.props;

    return new Promise((resolve) => {
      const cumulativeQuestions = get(
        evalPlan,
        'evaluationQuestions',
        []
      ).filter((question) => Boolean(question.cumulative));

      if (!file || isEmpty(cumulativeQuestions)) {
        resolve(0);
        return;
      }

      Papa.parse(file, {
        header: true,
        skipEmptyLines: 'greedy',
        complete: ({ data = [] }) => {
          const headerPairs = cumulativeQuestions.map((question) => {
            const title = get(question, 'outcome.title', '');
            return {
              afterKey: t('activity.evaluation_plan.after_1_to_10', {
                outcomeTitle: title,
              }),
              beforeKey: t('activity.evaluation_plan.before_1_to_10', {
                outcomeTitle: title,
              }),
            };
          });

          const entryCount = data.reduce((count, row) => {
            const hasNegativeImpact = headerPairs.some(
              ({ beforeKey, afterKey }) => {
                const beforeValue = Number(row[beforeKey]);
                const afterValue = Number(row[afterKey]);

                return (
                  Number.isFinite(beforeValue) &&
                  Number.isFinite(afterValue) &&
                  beforeValue > afterValue
                );
              }
            );

            return hasNegativeImpact ? count + 1 : count;
          }, 0);

          resolve(entryCount);
        },
        error: () => resolve(0),
      });
    });
  };

  uploadFileHandler = () => {
    this.setState({ loading: true }, async () => {
      try {
        const { file } = this.state;

        if (!file) {
          this.setState({ loading: false, isNoFile: true });
        } else {
          const {
            uploadActivityByMultipleObjectives,
            toggle,
            evalPlan,
            currentActivity,
            setIsFileChanged,
            setCsvUploadWarningCount,
          } = this.props;
          await setIsFileChanged(true);
          const activeCultureCount =
            get(evalPlan, 'method.response', null) === 'Participant' &&
            get(evalPlan, 'method.method', null) === 'Intercept' &&
            get(evalPlan, 'collectionMethod', null) === 'CULTURECOUNTS';

          const evalQuestion = evalPlan.evaluationQuestions;
          const projectId = currentActivity.id;
          const evaluationPlanId = evalPlan.id;

          let formData = new FormData();
          formData.set('uploadFile', file);

          const objectives = map(
            get(evalPlan, 'evaluationQuestions', []),
            (obj) => {
              return {
                key: obj.objectiveId,
                text: get(obj, 'outcome.title', '-'),
                value: obj.objectiveId,
              };
            }
          );

          if (evalQuestion) {
            if (activeCultureCount) {
              formData.append('isCultureCount', true);
            } else {
              formData.append('isCultureCount', false);
            }

            let objArr = [];
            objectives.forEach((objective) => {
              objArr.push(objective.value);
            });
            formData.append('objectives', JSON.stringify(objArr)); // adding array of objectives
          }

          // use this for passing value to route params
          const evaluation = {
            projectId: projectId,
            evaluationPlanId: evaluationPlanId,
          };

          const negativeImpactEntryCount =
            await this.getNegativeImpactEntryCount(file, evalPlan);

          await uploadActivityByMultipleObjectives(evaluation, formData);
          setCsvUploadWarningCount(negativeImpactEntryCount);
          await setIsFileChanged(false);
          this.setFile(null); // empty file state data
          toggle();
          this.setState({ loading: false, isNoFile: false });
        }
      } catch (error) {
        this.setState({ loading: false });
      }
    });
  };

  csvFileUploadForm = (toggle) => {
    const { t } = this.props;
    return (
      <>
        <div className="p-4">
          <BrowseFile
            label={t('activity.evaluation.upload_evaluation_template')}
            name="strategic"
            accept=".csv"
            buttonText={t('actions.browse').toUpperCase()}
            setFile={(data) => this.setFile(data.file)}
            loading={this.state.loading}
            csv
          />
          {this.state.isNoFile && (
            <span className="error-msg">
              {t('activity.evaluation.please_select_file')}
            </span>
          )}
        </div>
        <hr className="w-100 my-2" />
        <div className="model-buttons p-3">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => {
              this.setFile(null);
              toggle();
            }}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            className="Primary-Button"
            loading={this.state.loading}
            disabled={this.state.loading}
            type="submit"
            onClick={() => this.uploadFileHandler()}
          >
            {t('actions.save')}
          </Button>
        </div>
      </>
    );
  };

  render() {
    const { modal, toggle, t } = this.props;
    return (
      <Modal
        size="tiny"
        open={modal}
        onOpen={() => toggle()}
        closeIcon={
          <Icon onClick={() => toggle()} name="close" className="closeicon" />
        }
      >
        <Modal.Header>{t('activity.evaluation.upload_csv_file')}</Modal.Header>
        {this.csvFileUploadForm(toggle)}
      </Modal>
    );
  }
}

const EvaluationPlanChild = (props) => {
  const { t } = props;
  const [modal, setModal] = useState(false);
  const [isFileChanged, setIsFileChanged] = useState(false); // to handle common upload file was uploaded/ modified
  // Defaults to Yes; initOrderedObjectives() overwrites this from the
  // persisted inReport value on mount, but new/never-toggled evaluation
  // questions should still read as "Show in report: Yes" before that runs.
  const [checked, setToggle] = useState(true);
  const [csvUploadWarningCount, setCsvUploadWarningCount] = useState(0);

  const { evalPlan, currentActivity, user } = props;
  const csvUploadWarningStorageKey = getCsvUploadWarningStorageKey(
    currentActivity.id,
    evalPlan.id
  );

  const isDisabledCsvFunctionalities =
    get(evalPlan, 'dateMeasured', false) || get(evalPlan, 'isDisabled', false);

  const isDisabled =
    get(evalPlan, 'isDisabled', false) ||
    getPageDisable(currentActivity, user, 'project.edit.evaluationPlan');

  // toggler for managing upload csv modal (import csv section)
  const toggle = () => {
    setModal(!modal);
  };

  useEffect(() => {
    const storedWarningCount = Number(
      sessionStorage.getItem(csvUploadWarningStorageKey) || 0
    );
    setCsvUploadWarningCount(storedWarningCount > 0 ? storedWarningCount : 0);
  }, [csvUploadWarningStorageKey]);

  useEffect(() => {
    sessionStorage.setItem(
      csvUploadWarningStorageKey,
      String(csvUploadWarningCount)
    );
  }, [csvUploadWarningCount, csvUploadWarningStorageKey]);

  const setChartToReport = (
    inReport,
    selectedObjective,
    ignoreAPISave = false
  ) => {
    const { evalManage } = props;
    if (!ignoreAPISave) {
      evalManage(currentActivity.id, evalPlan.id, selectedObjective, {
        inReport,
      });
    }
    setToggle(inReport);
  };

  // =============================== Upload Template  ===================================

  // TAK-2088: the Culture Counts download/import instructions only show while
  // the instance still offers Culture Counts (the upload's own handling of
  // those older plans is unchanged)
  const activeCultureCount =
    INSTANCE_WITH_CULTURE_COUNTS &&
    get(evalPlan, 'method.response', null) === 'Participant' &&
    get(evalPlan, 'method.method', null) === 'Intercept' &&
    get(evalPlan, 'collectionMethod', null) === 'CULTURECOUNTS';

  const csvRespondentType = String(
    get(evalPlan, 'method.response', 'participant')
  ).toLowerCase();

  const isCsvImportEnabled =
    evalPlan.collectionMethod === 'LINK' ||
    evalPlan.collectionMethod === 'CSV' ||
    evalPlan.collectionMethod === 'CULTURECOUNTS';

  const evalQuestion = evalPlan.evaluationQuestions;

  let headers = [
    {
      label: t('activity.evaluation.response_date'),
      key: 'responseDate',
    },
  ];

  for (let index = 0; index < evalQuestion.length; index++) {
    let title = evalPlan.evaluationQuestions[index].outcome.title;
    let cumulative = evalQuestion[index].cumulative; // cumulative decides whether prev responses is there

    if (Boolean(cumulative)) {
      headers.push(
        {
          label: `After ${title} (1-10)`,
          key: 'afterResponse',
        },
        {
          label: `Before ${title} (1-10)`,
          key: 'beforeResponse',
        },
        {
          label: `${title} comment`,
          key: 'reason',
        }
      );
    } else {
      headers.push(
        {
          label: `${title} - rating (1-10)`,
          key: 'participantResponse',
        },
        {
          label: `${title} comment`,
          key: 'reason',
        }
      );
    }
  }

  if (evalPlan.isTakker) {
    headers.push({ label: 'takker', key: 'takker' });
  }

  map(get(evalPlan, 'customQuestions', []), (question) => {
    const label = get(question, 'label') || get(question, 'type', '');
    if (label) {
      headers.push({
        label,
        key: `customQuestion:${question.id}:${label}`,
      });
    }
  });

  return (
    <Segment className="p-2">
      <div className="eval-que-div">
        <div className="eval-que-header">
          {evalPlan.collectionMethod === 'MANUAL' ? (
            <p>{t('activity.evaluation.manual_evaluation_instructions')}</p>
          ) : null}

          {/* // evaluation isNewCsvFeature: upload all objectives data in one CSV file */}
          {isCsvImportEnabled &&
          evalPlan.isNewCsvFeature &&
          evalPlan.methodId !== 9 ? (
            <Segment
              disabled={
                currentActivity.statusId === 3 || isDisabledCsvFunctionalities
                  ? true
                  : false
              }
            >
              <label className="eval-que-sub-header mt-4 mb-2">
                {t('activity.evaluation.import_csv_data')}
              </label>
              <p>
                {activeCultureCount ? (
                  <div className="ml-4 my-2">
                    <ol className="p-0">
                      <li>
                        <p className="mb-3">
                          {' '}
                          {t(
                            'activity.evaluation.download_culture_counts_results'
                          )}
                        </p>

                        {activeCultureCount && (
                          <>
                            <div className="eval-culture-count-container my-2">
                              <a
                                href={'https://culturecounts.cc/sign-in'}
                                rel="noopener noreferrer"
                                target="_blank"
                                className="culture-count-a"
                              >
                                <div className="eval-culture-count">
                                  <span>
                                    {t(
                                      'activity.evaluation.go_to_culture_counts'
                                    )}
                                    <Icon
                                      name="external alternate"
                                      className="ml-3 mb-1"
                                    />
                                  </span>
                                </div>
                              </a>
                            </div>
                          </>
                        )}
                      </li>

                      <li>
                        <p className="mb-2 mt-4">
                          {t(
                            'activity.evaluation.import_culture_counts_csv_file_into_takso'
                          )}
                        </p>
                        <div className="row">
                          <Button
                            icon
                            labelPosition="left"
                            className="upload-btn my-2"
                            onClick={() => toggle()}
                            disabled={
                              isDisabled || isDisabledCsvFunctionalities
                            }
                          >
                            <Icon name="upload" />
                            {t(
                              'activity.evaluation.import_culture_counts_survey'
                            )}
                          </Button>
                        </div>
                      </li>
                    </ol>
                  </div>
                ) : (
                  t('activity.evaluation.csv_template_instructions', {
                    csvRespondentType,
                  })
                )}
              </p>
              <div>
                {!activeCultureCount ? (
                  <>
                    <div className="row">
                      {' '}
                      <CSVLink
                        className={isDisabled ? 'disabled-csv' : ''}
                        headers={headers}
                        data={evalPlan.isTakker ? [{ takker: 'true' }] : []}
                        filename={'template.csv'}
                      >
                        <Button
                          icon
                          labelPosition="left"
                          className="upload-btn"
                          disabled={isDisabled || isDisabledCsvFunctionalities}
                        >
                          <Icon name="cloud download" />
                          {evalPlan.isTakker
                            ? t(
                                'activity.evaluation.download_takker_csv_template'
                              )
                            : t('activity.evaluation.download_csv_template')}
                        </Button>
                      </CSVLink>
                      <Button
                        icon
                        labelPosition="left"
                        className="upload-btn"
                        onClick={() => toggle()}
                        disabled={isDisabled || isDisabledCsvFunctionalities}
                      >
                        <Icon name="upload" />
                        {t('activity.evaluation.upload_csv')}
                      </Button>{' '}
                    </div>
                    {csvUploadWarningCount > 0 && (
                      <div className="ui info message mt-3">
                        <p className="header">
                          {csvUploadWarningCount === 1
                            ? t('activity.evaluation.participation_warning', {
                                csvUploadWarningCount,
                              })
                            : t(
                                'activity.evaluation.participation_warning_plural',
                                { csvUploadWarningCount }
                              )}
                        </p>
                        <p>
                          {csvUploadWarningCount === 1
                            ? t('activity.evaluation.participation_warning2')
                            : t(
                                'activity.evaluation.participation_warning2_plural'
                              )}
                          <br />
                          {t(
                            'activity.evaluation.participation_warning_correct'
                          )}
                          <br />
                          {t(
                            'activity.evaluation.participation_warning_reupload'
                          )}
                        </p>
                      </div>
                    )}
                  </>
                ) : null}
              </div>
            </Segment>
          ) : null}
        </div>

        <UploadCsv
          modal={modal}
          toggle={() => toggle()}
          setIsFileChanged={setIsFileChanged} // to set common upload file was uploaded/ modified
          setCsvUploadWarningCount={setCsvUploadWarningCount}
          {...props}
          t={t}
        />

        {evalPlan.methodId === 9 ? (
          <div className="new-self-assess">
            <ActivityEvaluationSurvey
              {...props}
              checked={checked}
              setToggle={setToggle}
              setChartToReport={setChartToReport}
              isDisabled={isDisabled}
            />
          </div>
        ) : activeCultureCount ? (
          <div className="px-4">
            <EvaluationPlanCharts
              isFileChanged={isFileChanged} // to check common upload file was uploaded/ modified
              setIsFileChanged={setIsFileChanged} // to handle common upload file was uploaded/ modified from child component
              checked={checked}
              setToggle={setToggle}
              setChartToReport={setChartToReport}
              {...props}
            />
          </div>
        ) : (
          <div className="url-card  plan-documentation">
            <div className="obj-div">
              <div className="tabs-evaluation">
                <EvaluationPlanCharts
                  isFileChanged={isFileChanged} // to check common upload file was uploaded/ modified
                  setIsFileChanged={setIsFileChanged} // to handle common upload file was uploaded/ modified from child component
                  checked={checked}
                  setToggle={setToggle}
                  setChartToReport={setChartToReport}
                  {...props}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </Segment>
  );
};

const EvaluationPlanFinaliseSection = (props) => {
  const {
    t,
    evalPlan,
    currentActivity,
    user,
    evalPlanManage,
    evalPlanManageComplete,
    deleteEvaluationPlan,
    evaluationPlanTransformSelfAssess,
  } = props;

  const [errorResponseModal, setErrorResponseModal] = useState(false);
  const [errorConflictModal, setErrorConflictModal] = useState(false);
  const [switchSelfAssessModal, setSwitchSelfAssessModal] = useState(false);
  const [replaceSelfAssessModal, setReplaceSelfAssessModal] = useState(false);
  const [reopenEvaluationModal, setReopenEvaluationModal] = useState(false);
  const [seriesConflict, setSeriesConflict] = useState(false);

  const pageDisabled = getPageDisable(
    currentActivity,
    user,
    'project.edit.evaluationPlan'
  );

  const selfAssessed = get(evalPlan, 'method.response', '') === 'Self-assessed';
  const transformedToSelfAssessed = Boolean(
    get(evalPlan, 'isSelfAssessed', false)
  );
  const isSelfAssessedPlan = Boolean(
    selfAssessed || get(evalPlan, 'methodId', null) === 9
  );
  const isDisabled = get(evalPlan, 'isDisabled', false);
  const seriesParentId = get(evalPlan, 'seriesParentId', null);
  const hasResponses =
    Number(get(evalPlan, 'actualParticipantsEvaluated', 0)) > 0 ||
    get(evalPlan, 'haveResponses', false);
  const responseCountFromQuestions = Math.max(
    0,
    ...map(get(evalPlan, 'evaluationQuestions', []), (evaluation) =>
      Number(get(evaluation, 'actualParticipantsEvaluated', 0))
    )
  );
  const responseCount = Math.max(
    Number(get(evalPlan, 'actualParticipantsEvaluated', 0)),
    responseCountFromQuestions,
    hasResponses ? 1 : 0
  );
  const evaluationGroupNames = map(
    get(evalPlan, 'participantGroups', []),
    (participantGroup) => get(participantGroup, 'targetGroup.name', null)
  ).filter(Boolean);
  const isCompleted = Boolean(
    get(evalPlan, 'dateMeasured', null) && !isDisabled
  );
  const isReplaced = Boolean(transformedToSelfAssessed && isSelfAssessedPlan);

  const anotherSeriesPlanActive = Boolean(
    seriesParentId &&
    find(get(currentActivity, 'evaluationPlans', []), (plan) => {
      const siblingIsCompleted = Boolean(
        get(plan, 'dateMeasured', null) && !get(plan, 'isDisabled', false)
      );
      const siblingIsSelfAssessed = Boolean(
        get(plan, 'method.response', '') === 'Self-assessed' ||
        get(plan, 'methodId', null) === 9
      );
      return (
        get(plan, 'seriesParentId', null) === seriesParentId &&
        get(plan, 'id', null) !== get(evalPlan, 'id', null) &&
        get(plan, 'isSeriesActive', false) &&
        !siblingIsCompleted &&
        !siblingIsSelfAssessed
      );
    })
  );

  const hasExistingSelfAssessedWithSameGroups = Boolean(
    find(get(currentActivity, 'evaluationPlans', []), (plan) => {
      if (get(plan, 'id', null) === get(evalPlan, 'id', null)) return false;

      const isSelfAssessedPlan =
        get(plan, 'method.response', '') === 'Self-assessed' ||
        get(plan, 'methodId', null) === 9;
      if (!isSelfAssessedPlan) return false;

      const currentGroupIds = map(
        get(evalPlan, 'participantGroups', []),
        (group) => Number(get(group, 'targetGroup.id', 0))
      )
        .filter(Boolean)
        .sort((a, b) => a - b);

      const otherGroupIds = map(get(plan, 'participantGroups', []), (group) =>
        Number(get(group, 'targetGroup.id', 0))
      )
        .filter(Boolean)
        .sort((a, b) => a - b);

      if (currentGroupIds.length !== otherGroupIds.length) return false;
      return currentGroupIds.every((id, idx) => id === otherGroupIds[idx]);
    })
  );

  const getPutValues = () => {
    let allValue = {
      name: get(evalPlan, 'name', ''),
      collectionMethod: 'LINK',
      objectives: map(
        get(evalPlan, 'evaluationQuestions', []),
        (evaluation) => evaluation.objectiveId
      ),
      participantGroups: map(
        get(evalPlan, 'participantGroups', []),
        (participantGroup) => participantGroup.targetGroup.id
      ),
      methodId: 9,
      sampleSize: get(evalPlan, 'sampleSize', ''),
      isSelfAssessed: true,
    };
    allValue.evaluationQuestions = map(allValue.objectives, (objective) => {
      const outcome = find(
        get(currentActivity, 'objective', []),
        (e) => e.id === objective
      );
      return {
        objectiveId: objective,
        outcomeId: outcome.outcomeId,
        methodId: 9,
      };
    });
    return allValue;
  };

  const onConfirm = async () => {
    const allValue = getPutValues();
    allValue.isSeries = evalPlan.seriesParentId ? true : false;
    await evaluationPlanTransformSelfAssess(
      currentActivity.id,
      evalPlan.id,
      allValue,
      {
        resetForm: () => {},
        forceFormReset: () => {},
        setErrorResponseModal,
        setErrorConflictModal,
        setSeriesConflict,
      }
    );
  };

  const completeEvalPlan = async () => {
    const dateMeasured = moment().toDate();
    const form = {
      isSelfAssessed: false,
      dateMeasured,
      isSeries: evalPlan.seriesParentId ? true : false,
      collectionMethod: evalPlan.collectionMethod,
    };
    await evalPlanManageComplete(
      currentActivity.id,
      evalPlan.id,
      form,
      formatEvaluationPlanDisplayName(evalPlan)
    );
  };

  const reopenEvaluation = async () => {
    setReopenEvaluationModal(false);
    const form = {
      isSeries: false,
      dateMeasured: null,
      isDisabled: false,
      collectionMethod: evalPlan.collectionMethod,
      isSelfAssessed: false,
    };
    await evalPlanManage(
      currentActivity.id,
      evalPlan.id,
      form,
      formatEvaluationPlanDisplayName(evalPlan)
    );
  };

  const removeCurrentEvaluationPlan = async () => {
    await deleteEvaluationPlan(
      currentActivity.id,
      evalPlan.id,
      Boolean(evalPlan.seriesParentId)
    );
    setErrorResponseModal(false);
  };

  return (
    <>
      <Segment disabled={currentActivity.statusId === 3}>
        <div className="url-card  plan-documentation">
          <div className="obj-div">
            {!isSelfAssessedPlan &&
              !isCompleted &&
              !isReplaced &&
              !hasResponses && (
                <div className="mt-2">
                  <div className="method-heading-box">
                    {t('activity.evaluation_plan.no_responses_recorded')}
                  </div>
                  <Button
                    className="modal-proceed"
                    disabled={isDisabled || pageDisabled}
                    onClick={() => setSwitchSelfAssessModal(true)}
                  >
                    {t('activity.evaluation_plan.switch_to_manager_assessed')}
                  </Button>
                </div>
              )}

            {!isSelfAssessedPlan &&
              !isCompleted &&
              !isReplaced &&
              hasResponses && (
                <div className="mt-2">
                  <Popup
                    content={t(
                      'activity.evaluation_plan.mark_as_complete_tooltip'
                    )}
                    trigger={
                      <Button
                        className="modal-proceed mr-2"
                        disabled={isDisabled || pageDisabled}
                        onClick={() => completeEvalPlan()}
                      >
                        {t('activity.evaluation_plan.mark_as_complete')}
                      </Button>
                    }
                  />
                  <Button
                    className="modal-cancel"
                    disabled={isDisabled || pageDisabled}
                    onClick={() => {
                      if (hasExistingSelfAssessedWithSameGroups) {
                        setErrorResponseModal(true);
                      } else {
                        setReplaceSelfAssessModal(true);
                      }
                    }}
                  >
                    {t(
                      'activity.evaluation_plan.replace_with_manager_assessed_button'
                    )}
                  </Button>
                </div>
              )}

            {!isSelfAssessedPlan && isCompleted && !isReplaced && (
              <div className="mt-2">
                <div className="ui info message">
                  <div className="header">{t('common.completed')}</div>
                  {get(evalPlan, 'dateMeasured', null) && (
                    <p>
                      {moment(get(evalPlan, 'dateMeasured')).format(
                        'D MMM YYYY'
                      )}
                    </p>
                  )}
                </div>
                <Popup
                  content={
                    anotherSeriesPlanActive
                      ? t(
                          'activity.evaluation_plan.reopen_only_available_when_complete'
                        )
                      : t('activity.evaluation_plan.reopen_allows_you_to_add')
                  }
                  trigger={
                    <span className="d-inline-block mt-2">
                      <Button
                        className="modal-proceed"
                        disabled={
                          isDisabled || pageDisabled || anotherSeriesPlanActive
                        }
                        onClick={() => setReopenEvaluationModal(true)}
                      >
                        {t('activity.evaluation_plan.reopen_evaluation')}
                      </Button>
                    </span>
                  }
                />
              </div>
            )}

            {isReplaced && (
              <div className="mt-2">
                <div className="d-flex align-items-center">
                  <Popup
                    content={t(
                      'activity.evaluation_plan.switch_to_manager_assessed_tooltip_warning'
                    )}
                    trigger={
                      <span className="ui grey label mr-2">
                        {t('common.replaced')}
                      </span>
                    }
                  />
                  <span>
                    {t(
                      'activity.evaluation_plan.plan_switched_to_manager_assessed'
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </Segment>

      <Modal
        size="small"
        onClose={() => setSwitchSelfAssessModal(false)}
        open={switchSelfAssessModal}
      >
        <Modal.Header>
          {t('activity.evaluation_plan.switch_to_manager_assessed')}
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Trans
              i18nKey="activity.evaluation_plan.switch_to_manager_assessed_will_replace_eval_plan"
              components={{
                div: <div className="ui negative message" />,
                groupList: isEmpty(evaluationGroupNames) ? (
                  <></>
                ) : (
                  <ul>
                    {map(evaluationGroupNames, (groupName, index) => (
                      <li key={`eval-group-${index}`}>{groupName}</li>
                    ))}
                  </ul>
                ),
              }}
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="modal-cancel"
            content={t('actions.cancel')}
            onClick={() => setSwitchSelfAssessModal(false)}
          />
          <Button
            className="modal-proceed"
            content={t('actions.continue')}
            onClick={() => {
              setSwitchSelfAssessModal(false);
              onConfirm();
            }}
          />
        </Modal.Actions>
      </Modal>

      <Modal
        size="small"
        onClose={() => setReplaceSelfAssessModal(false)}
        open={replaceSelfAssessModal}
      >
        <Modal.Header>
          {t(
            'activity.evaluation_plan.replace_with_manager_assessed_evaluation'
          )}
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Trans
              i18nKey="activity.evaluation_plan.replace_with_manager_assessed_evaluation_warning"
              components={{
                ul: <ul />,
                li: <li />,
                div: <div className="ui negative message" />,
              }}
              values={{
                evalPlanName: get(evalPlan, 'name', 'This evaluation'),
                responseCount,
              }}
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="modal-cancel"
            content={t('actions.cancel')}
            onClick={() => setReplaceSelfAssessModal(false)}
          />
          <Button
            className="modal-proceed"
            content={t('actions.continue')}
            onClick={() => {
              setReplaceSelfAssessModal(false);
              onConfirm();
            }}
          />
        </Modal.Actions>
      </Modal>

      <Modal
        size="small"
        onClose={() => setReopenEvaluationModal(false)}
        open={reopenEvaluationModal}
      >
        <Modal.Header>
          {t('activity.evaluation_plan.reopen_evaluation')}
        </Modal.Header>
        <Modal.Content>
          <p>{t('activity.evaluation_plan.reopening_allows_new_data')}</p>
          <p>{t('actions.do_you_want_to_continue')}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="modal-cancel"
            content={t('actions.cancel')}
            onClick={() => setReopenEvaluationModal(false)}
          />
          <Button
            className="modal-proceed"
            content={t('actions.continue')}
            onClick={() => reopenEvaluation()}
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onClose={() => setErrorResponseModal(false)}
        open={errorResponseModal}
        size="small"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          {t(
            'activity.evaluation_plan.error_messages.duplicate_manager_assessed_plan_found'
          )}
        </Modal.Header>
        <Modal.Content>
          <Trans
            i18nKey="activity.evaluation_plan.error_messages.cannot_transfer_to_manager_assessed"
            components={{ div: <div className="ui negative message" /> }}
            values={{ responseCount }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            content={t('actions.cancel')}
            className="modal-cancel"
            onClick={() => setErrorResponseModal(false)}
          />
          <Button
            content={t('activity.evaluation_plan.remove_plan')}
            className="modal-proceed"
            onClick={() => removeCurrentEvaluationPlan()}
          />
        </Modal.Actions>
      </Modal>
      <Modal
        onClose={() => setErrorConflictModal(false)}
        open={errorConflictModal}
        size="small"
      >
        <Modal.Header>
          {seriesConflict
            ? t(
                'activity.evaluation_plan.replace_with_manager_assessed_evaluation'
              )
            : t(
                'activity.evaluation_plan.error_messages.duplicate_manager_assessed_plan_found'
              )}
        </Modal.Header>
        <Modal.Content>
          {seriesConflict ? (
            <Trans i18nKey="activity.evaluation_plan.error_messages.cannot_be_transferred_to_manager_assessed_because_of_series_conflict" />
          ) : (
            <Trans
              i18nKey="activity.evaluation_plan.error_messages.cannot_be_transferred_to_manager_assessed"
              components={{ div: <div className="ui negative message" /> }}
              values={{ responseCount }}
            />
          )}
        </Modal.Content>
        <Modal.Actions>
          {seriesConflict ? (
            <Button
              className="modal-cancel"
              onClick={() => setErrorConflictModal(false)}
            >
              {t('actions.ok')}
            </Button>
          ) : (
            <>
              <Button
                className="modal-cancel"
                onClick={() => setErrorConflictModal(false)}
              >
                {t('actions.cancel')}
              </Button>
              <Button
                className="modal-proceed"
                onClick={() => removeCurrentEvaluationPlan()}
              >
                {t('activity.evaluation_plan.remove_plan')}
              </Button>
            </>
          )}
        </Modal.Actions>
      </Modal>
    </>
  );
};

const EvaluationPlan = (props) => {
  const { user, currentActivity, t } = props;

  const dispatch = useDispatch();
  const evalAssesmentTypes = useSelector(
    (state) => state.extra.evalAssesmentTypes
  );
  const evalReasons = useSelector((state) => state.extra.evalReasons);

  const [isFileChanged, setIsFileChanged] = useState(false);

  useEffect(() => {
    dispatch(getEvalReasons());
    dispatch(getEvalAssesmentTypes());
  }, []);

  const dateMeasured = get(props.evalPlan, 'dateMeasured', null);
  const seriesParentId = get(props.evalPlan, 'seriesParentId', null);
  const isSeriesActive = get(props.evalPlan, 'isSeriesActive', null);
  const selfAssessed =
    get(props.evalPlan, 'method.response', '') === 'Self-assessed';
  const isDisabled = get(props.evalPlan, 'isDisabled', false);

  const evaluationQuestions = get(props.evalPlan, 'evaluationQuestions', []);
  const areSelfAssessQuestionsComplete =
    !isEmpty(evaluationQuestions) &&
    evaluationQuestions.every((evaluationQuestion) => {
      const hasReason = Boolean(
        get(evaluationQuestion, 'selfAssessmentReason', null)
      );
      const hasResponses =
        sum(flattenDeep(get(evaluationQuestion, 'participantResponse', []))) !==
        0;
      return hasReason && hasResponses;
    });

  const isSelfAssessPlanComplete = Boolean(
    get(props.evalPlan, 'methodReason', null) &&
    !isEmpty(get(props.evalPlan, 'assessmentTypes', [])) &&
    get(props.evalPlan, 'actualParticipantsEvaluated', null) &&
    areSelfAssessQuestionsComplete
  );

  const pageDisabled = getPageDisable(
    currentActivity,
    user,
    'project.edit.evaluationPlan'
  );

  return (
    <Fragment>
      <Segment>
        {get(props, 'evalPlan.isDisabled', false) ? (
          <EvalPlanDisable {...props.evalPlan} />
        ) : null}
        <EvaluationPlanMeasure {...props} t={t} />
        {(seriesParentId && dateMeasured) ||
        (!seriesParentId && selfAssessed) ||
        !seriesParentId ||
        (seriesParentId && isSeriesActive) ? (
          <div className="eval-plan-accordion">
            {!selfAssessed && !dateMeasured && (
              <CustomAccordion
                extraMargin
                headerStyle={{ color: '#EF8123' }}
                titleAvailable={false}
                title={''}
                open={t('activity.evaluation.show_survey_information')}
                close={t('activity.evaluation.hide_survey_information')}
                evalPlan={true}
                children={
                  <>
                    <SurveyContainer
                      key={props.evalPlan.name}
                      evalPlan={props.evalPlan}
                      {...props}
                      pageDisabled={pageDisabled}
                    />
                  </>
                }
              />
            )}

            {selfAssessed && !isDisabled && !isSelfAssessPlanComplete && (
              <Grid>
                <Grid.Column mobile={16} tablet={8} computer={16}>
                  <div className="url-card  plan-documentation">
                    <div className="obj-div">
                      <div className="ui message">
                        {t('activity.evaluation.mgr_assessment_instructions')}
                      </div>
                    </div>
                  </div>
                </Grid.Column>
              </Grid>
            )}

            <CustomAccordion
              id={`accordion_${props.evalPlan.id}`}
              name={`accordion_${props.evalPlan.id}`}
              extraMargin
              headerStyle={{ color: '#EF8123' }}
              titleAvailable={false}
              title={''}
              open={t('activity.evaluation.show_evaluation_details')}
              close={t('activity.evaluation.hide_evaluation_details')}
              evalPlan={true}
              children={
                !isEmpty(evalAssesmentTypes) &&
                !isEmpty(evalReasons) && (
                  <EvaluationPlanChild
                    isFileChanged={isFileChanged} // to check common upload file was uploaded/ modified
                    setIsFileChanged={setIsFileChanged} // to handle common upload file was uploaded/ modified from child component
                    evalAssesmentTypes={evalAssesmentTypes}
                    evalReasons={evalReasons}
                    {...props}
                    pageDisabled={pageDisabled}
                    t={t}
                  />
                )
              }
            />
          </div>
        ) : null}

        <EvaluationPlanFinaliseSection {...props} />
      </Segment>
      <br />
    </Fragment>
  );
};

class EvaluationPlanSection extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { currentActivity, getEvaluationPlans } = this.props;
    getEvaluationPlans(currentActivity.id);
  }

  render() {
    return (
      <Segment className="survey-seg">
        <div className="survey-div">
          <EvalPlans singleEvalPlans {...this.props} t={this.props.t} />
        </div>
      </Segment>
    );
  }
}

class EvalPlans extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      currentActivity: { evaluationPlans = [] },
    } = this.props;

    if (isEmpty(evaluationPlans)) return null;
    return (
      <div className="eval-plans-list">
        {map(evaluationPlans, (plan, i) => (
          <div key={i} className="report-eval-plan-top-border">
            <EvaluationPlan key={i} evalPlan={plan} {...this.props} />
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    user: state.authentication.user,
    helpTips: state.extra.activityHelpTips,
    participantsChange: state.report.participantsChange,
    participantsChangePrePost: state.report.participantsChangePrePost,
    participants: state.report.participants,
    projectLoading: state.report.projectLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      evalPlanManage,
      evalManage,
      evalPlanManageComplete,
      deleteEvaluationPlan,
      updateEvaluationPlan,
      evaluationPlanTransformSelfAssess,
      getProjectOutcomeSummary,
      updateOutcomeChart,
      updateEvaluationPlanName,
      uploadActivityByMultipleObjectives,
      updateSeriesSubtitle,
      deleteSeriesSubtitle,
      getEvaluationPlans,
    },
    dispatch
  );
};

EvaluationPlanSection = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EvaluationPlanSection));

export { EvaluationPlanSection };
